
export class PanchangInputHelper {
    constructor(private document: any,
        private punchInstance: any) {


    }
    inputClick(event: MouseEvent) {

        event.preventDefault();
        const document = this.document;
        const node = this.punchInstance.inputField.nativeElement;
        const nodeLen = node.value.length;


        if (document.selection) {
            node.focus();
            const sel = document.selection.createRange();
            node.focus();

        } else if (node.selectionStart || node.selectionStart === 0) {

            let start = 0, end = 2;
            const startPos = node.selectionStart;
            const scrollTop = node.scrollTop;
            if (nodeLen) {
                switch (startPos) {
                    case 3: start = 3; end = 5;
                        break;
                    case 5: start = 3; end = 5;
                        break;
                    case 4: start = 3; end = 5;
                        break;
                    case 6: start = 6; end = 10;
                        break;
                    case 7: start = 6; end = 10;
                        break;
                    case 8: start = 6; end = 10;
                        break;
                    case 9: start = 6; end = 10;
                        break;
                    case 10: start = 6; end = 10;
                        break;
                    default: start = 0; end = 2;

                }

                node.scrollTop = scrollTop;
                node.focus();
                node.setSelectionRange(start, end);

            }
            node.scrollTop = scrollTop;
        } else {
            // IE input[type=text] and other browsers
            node.focus();
            node.value = node.value;    // forces cursor to end

        }

    }
    keyDownListener(event: KeyboardEvent) {

        switch (event.keyCode) {
            case 9: event.preventDefault(); this.selectionNavigation(); break; // tab
            case 37: event.preventDefault(); this.selectionNavigation(true); // left arrow
                break;
            case 38:
                event.preventDefault();
                this.insertAtCaretPos(true); break; // up arrow
            case 40: event.preventDefault();
                this.insertAtCaretPos(false); break; // dwn arrow
            case 39: event.preventDefault(); this.selectionNavigation();
                break;
            default:
                if (event.keyCode > 64 && event.keyCode <= 95 || event.keyCode > 105 && event.keyCode <= 223
                    || event.keyCode > 15 && event.keyCode <= 36 || event.keyCode === 8 || event.keyCode > 44 && event.keyCode <= 46) {
                    event.preventDefault();
                } else {
                    event.preventDefault();
                    this.inputDateChange(event.key);
                }
        }

    }
    insertAtCaretPos(isUp: boolean) {
        const document = this.document;
        const node = this.punchInstance.inputField.nativeElement;
        const nodeLen = node.value.length;

        if (document.selection) {
            node.focus();
            node.focus();
        } else if (node.selectionStart || node.selectionStart === 0) {
            const startPos = node.selectionStart;
            const scrollTop = node.scrollTop;
            if (nodeLen) {
                switch (startPos) {
                    case 0: node.selectionStart = startPos + 2; node.selectionEnd = startPos + 2;
                        break;
                    case 1: node.selectionStart = startPos + 1; node.selectionEnd = startPos + 1;
                        break;
                    case 3: node.selectionStart = startPos + 2; node.selectionEnd = startPos + 2;
                        break;
                    case 4: node.selectionStart = startPos + 1; node.selectionEnd = startPos + 1;
                        break;
                    case 6: node.selectionStart = startPos + 10; node.selectionEnd = startPos + 10;
                        break;
                }
                const str = node.value.split('/');
                let day = +str[0]; let month = +str[1]; let year = +str[2];
                switch (node.selectionEnd) {
                    case 2:
                        const lastDate = new Date(year, month, 0).getDate();
                        if (isUp && day < lastDate) {
                            day++;
                        } else if (!isUp && day !== 1) { day--; } else if (!isUp && day <= 1) { day = lastDate; } else if (isUp && day >= lastDate) { day = 1; month++; }
                        break;
                    case 5:
                        if (isUp && month < 12) {
                            month++;
                        } else if (!isUp && month !== 1) { month--;
                        } else if (!isUp && month <= 1) {
                            month = 12;

                        } else if (isUp && month >= 12) { month = 1;year++; }
                        day=day>new Date(year, month, 0).getDate()?new Date(year, month, 0).getDate():day;
                        break;
                    case 10: if (isUp && year < 2100) { year++; } else if (!isUp && year > 1900) {
                        year--;
                    } else if (!isUp && year <= 1900) { year = 2100; } else if (isUp && year >= 2100) { year = 1900; }
                        break;

                }

                node.value = ((day < 10) ? '0' + day : day) + '/' + ((month < 10) ? '0' + month : month) + ('/' + year);
                this.punchInstance.inputDate = node.value;
                let selDay = new Date(year, month - 1, day);


                // if (DateService.isAfter(selDay, new Date()) || DateService.isSame(selDay, new Date()) || !this.punchInstance.options.startDate) {
                    selDay = this.getDateTime(selDay);
                    this.punchInstance.currentDate = selDay;
                    this.punchInstance.onChange(this.punchInstance.chosenDate = selDay);
                // }
                // else {
                //     const inputDate = moment(new Date()).format('DD/MM/YYYY');
                //     this.punchInstance.inputField.nativeElement.value = inputDate;
                //     this.punchInstance.onChange(new Date());
                // }
                node.selectionStart = startPos;
                node.selectionEnd = startPos;
                let start = 0, end = 2;
                if (nodeLen) {
                    switch (startPos) {
                        case 3: start = 3; end = 5;
                            break;
                        case 5: start = 3; end = 5;
                            break;
                        case 4: start = 3; end = 5;
                            break;
                        case 6: start = 6; end = 10;
                            break;
                        case 7: start = 6; end = 10;
                            break;
                        case 8: start = 6; end = 10;
                            break;
                        case 9: start = 6; end = 10;
                            break;
                        case 10: start = 6; end = 10;
                            break;
                        default: start = 0; end = 2;

                    }
                    node.setSelectionRange(start, end);
                    node.scrollTop = scrollTop;
                }
                node.scrollTop = scrollTop;

            }
            node.scrollTop = scrollTop;
        } else {
            node.focus();
            node.value = node.value;    // forces cursor to end
        }

    }
    selectionNavigation(isLeft = false) {
        const document = this.document;
        const node = this.punchInstance.inputField.nativeElement;
        const nodeLen = node.value.length;


        if (document.selection) {
            node.focus();
            const sel = document.selection.createRange();
            node.focus();

        } else if (node.selectionStart || node.selectionStart === 0) {

            let start = 0, end = 2;
            const startPos = node.selectionStart;
            const scrollTop = node.scrollTop;
            if (nodeLen) {
                if (!isLeft) {
                    switch (startPos) {
                        case 0: start = start + 3;
                            end = end + 3;
                            break;
                        case 3: start = start + 6;
                            end = end + 10;
                            break;
                        case 6: start = 0; end = 2;
                            break;
                        default: start = 0; end = 2;

                    }
                } else {
                    switch (startPos) {
                        case 0: start = start + 6;
                            end = end + 10;
                            break;
                        case 3: start = 0; end = 2;
                            break;
                        case 6: start = start + 3;
                            end = end + 3;
                            break;
                        default: start = 0; end = 2;

                    }
                }
                node.scrollTop = scrollTop;
                node.focus();
                node.setSelectionRange(start, end);

            }
            node.scrollTop = scrollTop;
        } else {
            // IE input[type=text] and other browsers
            node.focus();
            node.value = node.value;    // forces cursor to end

        }

    }
    inputDateChange(str: string) {
        const document = this.document;
        const node = this.punchInstance.inputField.nativeElement;
        const nodeLen = node.value.length;

        if (document.selection) {
            node.focus();

        } else if (node.selectionStart || node.selectionStart === 0) {

            let start = 0, end = 2;
            const startPos = node.selectionStart;
            const scrollTop = node.scrollTop;
            if (nodeLen) {
                switch (startPos) {
                    case 3:
                        if (isNumber(str)) {
                            ++this.punchInstance.monthInput;
                            const a = node.value[startPos + 1];
                            const b = node.value[startPos];
                            const second: string = node.value.split('/')[1];
                            if (+str > 2) {
                                node.value = repStrByidx(startPos, node.value, '0' + str);
                                start = 6; end = 10;
                                this.punchInstance.monthInput = 0;

                            } else if (+str <= 1 && this.punchInstance.monthInput <= 1) {

                                node.value = repStrByidx(startPos, node.value, '0');
                                node.value = repStrByidx(startPos + 1, node.value, str);
                                start = 3; end = 5;
                            } else if (second[0] === '0' && this.punchInstance.monthInput === 2) {
                                node.value = repStrByidx(startPos, node.value, a);
                                node.value = repStrByidx(startPos + 1, node.value, str);
                                if (+node.value.split('/')[1] > 12) {
                                    node.value = repStrByidx(startPos, node.value, '1');
                                    node.value = repStrByidx(startPos + 1, node.value, '2');
                                    start = 6; end = 10;
                                } else if (+node.value.split('/')[1] === 0) {
                                    node.value = repStrByidx(startPos, node.value, '0');
                                    node.value = repStrByidx(startPos + 1, node.value, '1');
                                    start = 6; end = 10;
                                }
                                start = 6; end = 10;
                                this.punchInstance.monthInput = 0;
                            }
                            const year = +node.value.split('/')[2], month = +node.value.split('/')[1], day = +node.value.split('/')[0];
                            const selDay = new Date(year, month - 1, day);
                            // if (DateService.isAfter(selDay, new Date()) || DateService.isSame(selDay, new Date())) {

                                this.punchInstance.currentDate = selDay;
                                this.punchInstance.onChange(this.punchInstance.chosenDate = selDay);
                            // } else {
                            //     const inputDate = moment(new Date()).format('DD/MM/YYYY');
                            //     this.punchInstance.inputField.nativeElement.value = inputDate;
                            //     this.punchInstance.onChange(new Date());
                            // }
                        }
                        break;
                    case 5: start = 3; end = 5;
                        break;
                    case 4: start = 3; end = 5;
                        break;
                    case 6: start = 6; end = 10;
                        break;
                    case 7: start = 6; end = 10;
                        break;
                    case 8: start = 6; end = 10;
                        break;
                    case 9: start = 6; end = 10;
                        break;
                    case 10: start = 6; end = 10;
                        break;
                    default:
                        if (isNumber(str)) {
                            ++this.punchInstance.dateInput;
                            const a = node.value[startPos + 1];
                            const b = node.value[startPos];
                            const first: string = node.value.split('/')[0];
                            if (+str * 10 > 31 && this.punchInstance.dateInput === 1) {
                                node.value = repStrByidx(startPos, node.value, '0' + str);
                                start = 3; end = 5;
                                this.punchInstance.dateInput = 0;

                            } else if (+str <= 3 && this.punchInstance.dateInput <= 1) {

                                node.value = repStrByidx(startPos, node.value, '0');
                                node.value = repStrByidx(startPos + 1, node.value, str);
                                start = 0; end = 2;
                            } else if (first[0] === '0') {
                                node.value = repStrByidx(startPos, node.value, a);
                                node.value = repStrByidx(startPos + 1, node.value, str);
                                if (+node.value.split('/')[0] > 31) {
                                    node.value = repStrByidx(startPos, node.value, '3');
                                    node.value = repStrByidx(startPos + 1, node.value, '1');
                                    start = 3; end = 5;
                                } else if (+node.value.split('/')[0] === 0) {
                                    node.value = repStrByidx(startPos, node.value, '0');
                                    node.value = repStrByidx(startPos + 1, node.value, '1');
                                    start = 3; end = 5;
                                }
                                start = 3; end = 5;
                                this.punchInstance.dateInput = 0;
                            }
                            const year = +node.value.split('/')[2], month = +node.value.split('/')[1], day = +node.value.split('/')[0];
                            const selDay = new Date(year, month - 1, day);
                            // if (DateService.isAfter(selDay, new Date()) || DateService.isSame(selDay, new Date())) {
                                this.punchInstance.currentDate = selDay;
                                this.punchInstance.onChange(this.punchInstance.chosenDate = selDay);
                            // } else {
                                // const inputDate = moment(new Date()).format('DD/MM/YYYY');
                                // this.punchInstance.inputField.nativeElement.value = inputDate;
                                // this.punchInstance.onChange(new Date());
                            // }
                        }

                }
                node.scrollTop = scrollTop;
                node.focus();
                node.setSelectionRange(start, end);

            }
            node.scrollTop = scrollTop;
        } else {
            // IE input[type=text] and other browsers
            node.focus();
            node.value = node.value;    // forces cursor to end

        }

    }
    getDateTime(ob: Date) {
        let date = new Date();
        ob.setHours(date.getHours());
        ob.setMinutes(date.getMinutes());
        ob.setSeconds(date.getSeconds());
        return ob;
    }
}
export function isNumber(value: any): value is number {
    return !isNaN(toInteger(value));
}
export function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}
export function repStrByidx(index: number, value: string, replacement: string) {
    return value.substr(0, index) + replacement + value.substr(index + replacement.length);
}
